import { Controller } from "@hotwired/stimulus"

/**
 * Collapsible content controller
 *
 * Provides expand/collapse functionality for content sections.
 * Collapsed by default.
 */
export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    // Ensure collapsed state on connect
    this.expanded = false
  }

  toggle() {
    this.expanded = !this.expanded

    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("hidden", !this.expanded)
    }

    if (this.hasIconTarget) {
      // Rotate chevron: 0deg when collapsed, 90deg when expanded
      this.iconTarget.classList.toggle("rotate-90", this.expanded)
    }
  }
}
